import "./init-sentry";

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
import "./setup-environment";

import {
  Environment,
  ServiceSuspenseHelper,
  useServiceProvider,
} from "@citychallenge/core";
import { PropsWithChildren, useLayoutEffect } from "react";

// import { initializeAmplitude } from "./amplitude-sdk";
import { useAdapters } from "./core/adapters/use-adapters";
import { MesssageDisplay } from "./message-display";
import { SuspenseShimmerWithUI } from "./suspense";
import { ConfirmProvider } from "./ui/confirm";

export default function ({ children }: PropsWithChildren<{}>) {
  const adapters = useAdapters();

  const serviceValues = useServiceProvider(adapters);

  useLayoutEffect(() => {
    document.body.setAttribute("data-environment", Environment.environmentName);
    // initializeAmplitude();
  }, []);

  return (
    <ConfirmProvider>
      <SuspenseShimmerWithUI>
        <ServiceSuspenseHelper {...serviceValues}>
          <MesssageDisplay />
          {children}
        </ServiceSuspenseHelper>
      </SuspenseShimmerWithUI>
    </ConfirmProvider>
  );
}
